// TTS Default Configuration
// These values match the Infer service defaults

import { DEFAULT_MODEL_ID, DEFAULT_MODEL_NAME } from './modelConfig';

export const TTS_DEFAULTS = {
  // Infer service voice synthesis parameters
  NOISE_SCALE: 0.667,      // Maps to stability (inverted: stability = 1 - noise_scale)
  NOISE_SCALE_W: 0.8,      // Maps to similarity_boost
  LENGTH_SCALE: 1.0,       // Maps to speed (inverted: speed = 1 / length_scale)
  
  // Frontend parameter defaults (VITS paper recommended values, consumed by Infer)
  SPEED: 1.0,
  STABILITY: 0.667,
  SIMILARITY_BOOST: 0.5,
  STYLE: 0.0,
  USE_SPEAKER_BOOST: false,

  // Granular pause settings (in milliseconds)
  COMMA_PAUSE_MS: 250,       // Pause after commas
  SEMICOLON_PAUSE_MS: 300,   // Pause after semicolons
  COLON_PAUSE_MS: 350,       // Pause after colons
  PERIOD_PAUSE_MS: 500,      // Pause after periods
  EXCLAMATION_PAUSE_MS: 550, // Pause after exclamation marks
  QUESTION_PAUSE_MS: 600,    // Pause after question marks
  ELLIPSIS_PAUSE_MS: 700,    // Pause after ellipsis
  PARAGRAPH_PAUSE_MS: 800,   // Pause between paragraphs
  
  // Model configuration (imported from centralized config)
  DEFAULT_MODEL_ID,
  DEFAULT_MODEL_NAME,
  
  // Text limits
  MAX_CHARS: 5000,
  MAX_EXPRESS_CHARS: 1000, // Maximum characters per request in Streaming mode ('express' is the legacy enum name)
  EXPRESS_CHAR_PERCENTAGE: 0.25, // Streaming mode allows 25% of plan's character limit
  MIN_READING_LEVEL: 6,
  
  // Credit costs
  CREDITS_PER_CHAR: 1,  // 1 credit per character (including whitespace)
  EXPRESS_MULTIPLIER: 1.5,
  // Same 1.5x as Express — streaming pins a Daphne ASGI slot +
  // in-flight PCM buffer + outbound bandwidth for the synthesis
  // duration. Mirror backend settings.TTS_STREAMING_MULTIPLIER.
  STREAMING_MULTIPLIER: 1.5,

  // Streaming eligibility gates. Mirror the constants in
  // django_backend/tts_submit_job/providers/gemini_provider.py +
  // django_backend/tts_submit_job/providers/infer_stream_provider.py +
  // streaming_views.py so the Processing Mode picker can pre-flight
  // the same checks the backend will enforce.
  STREAMING_MAX_INPUT_CHARS: 600,
  // ccl_ht_gem_pro = Creole Studio Pro (Gemini streaming)
  // ccl_ht_v100    = Creole Regional (Infer PathB streaming, added 2026-08-30)
  STREAMING_SUPPORTED_MODELS: ['ccl_ht_gem_pro', 'ccl_ht_v100'],
  // Which Infer models expose all three Processing Modes
  // (Standard + Express + Streaming). Studio Pro remains 2-mode
  // (Standard + Streaming) since Studio never honors Express.
  THREE_MODE_MODELS: ['ccl_ht_v100'],

  // Audio settings
  DEFAULT_LANGUAGE: 'ht',
  OUTPUT_FORMAT: 'mp3',
  SAMPLE_RATE: 22050,
};

export default TTS_DEFAULTS;